import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EmployeeType } from '../../../../shared/interfaces';
import { AppSettings } from '../../../../shared/models';
import { AbstractBasicDataApiService } from '../../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeTypeApiService extends AbstractBasicDataApiService<EmployeeType> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.employees.employeetype);
  }
}
